import { render } from "./ActiveItemFollowUp.vue?vue&type=template&id=3bd7e96a"
import script from "./ActiveItemFollowUp.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveItemFollowUp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Event/ActiveItemFollowUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bd7e96a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bd7e96a', __exports__)) {
    api.reload('3bd7e96a', __exports__)
  }
  
  module.hot.accept("./ActiveItemFollowUp.vue?vue&type=template&id=3bd7e96a", () => {
    api.rerender('3bd7e96a', render)
  })

}


export default __exports__